export enum IncludeRegionalProjectsEnum {
  NO_INCLUDE_PROJECTS,
  INCLUDE_COUNTRY_ADMIN,
  INCLUDE_UDR,
}
